import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { JWT_SERVICE } from '@core/services';
import { GuestService } from '@core/services/guest/guest.service';
import { map } from 'rxjs';

/**
 * Resolver used to GET a guest user from the GuestService. A JWT Token, which must contain a userId property, is needed to return a guest user.
 *
 * @returns guest
 */
export const guestResolver: ResolveFn<any> = () => {
  const _guest = inject(GuestService);
  const jwtService = inject(JWT_SERVICE);
  const jwtData = jwtService.getJwtData();

  return _guest.get(jwtData.userId).pipe(map((guest) => guest));
};
